/* Divine Leaf footer: link columns are accordions on mobile, always open on desktop. */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 990px)');
  var cols = Array.prototype.slice.call(document.querySelectorAll('[data-dlf-col]'));
  if (!cols.length) return;
  function apply() {
    cols.forEach(function (d) { if (mq.matches) d.open = true; else d.open = false; });
  }
  cols.forEach(function (d) {
    var s = d.querySelector('summary');
    if (s) s.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
  });
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
})();
